// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.solution-page{
  display: none;
}


.solution-wrapper {
    background-color: rgb(238, 238, 238);
  width: 100%;
  padding: 20px;
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  justify-content: center;
}
.solution-wrapper a {
  text-decoration: none;
}

.Sol-title{
    background-color: rgb(238, 238, 238);
    padding-top: 20px;
    font-size: 38px;
    font-weight: 700;
    color: #1e4f6c;
    text-align: center;
}

.solution-card {
  border: 1px solid rgb(219, 219, 219);
  background-color: rgb(255, 255, 255);
  width: 200px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 4px 5px;
  border-radius: 5px;
  gap: 4px;
  justify-content: center;
}

.solution-card:hover {
  background-color: rgb(241, 241, 241);
  box-shadow:
  0px 0px 5.3px rgba(0, 0, 0, 0.04),
  0px 0px 17.9px rgba(0, 0, 0, 0.06),
  0px 0px 80px rgba(0, 0, 0, 0.1)
;
transition: all 0.25s;


}
.solution-card img {
  width: 70px;
}

.solution-card p {
  font-size: 14px;
  text-align: center;
  font-weight: 500;
  color: rgb(80, 80, 80);
}

/* Responsive For Tablet Screen size 767px to 1023px START */
@media (max-width: 1023px) {

  .solution-page{
    display: block;
  }
  .Sol-title{

    font-size: 24px;
    font-weight: 700;

}

}

/* Responsive For Tablet Screen size 601px to 1023px END */

/*  */
/*  */
/* Responsive For Mobile Screen size 1024px to 1920px START */

@media (max-width: 767px) {

.solution-card {

  width: 80px;
 
}
.solution-card img {
    width: 20px;
  }
  .solution-img{
    width: 50px !important;
  }
.solution-card p {
    font-size: 8px;
  }
  .solution-card:hover {
    background-color:white;
    box-shadow: none;
  }

}

/* Responsive For Mobile Screen size 1024px to 1920px END */
`, "",{"version":3,"sources":["webpack://./src/Components/Solution page/SolutionIconStyles.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;;AAGA;IACI,oCAAoC;EACtC,WAAW;EACX,aAAa;EACb,aAAa;EACb,eAAe;EACf,SAAS;EACT,uBAAuB;AACzB;AACA;EACE,qBAAqB;AACvB;;AAEA;IACI,oCAAoC;IACpC,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;EACE,oCAAoC;EACpC,oCAAoC;EACpC,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC;;;;AAIF;AACA,qBAAqB;;;AAGrB;AACA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,4DAA4D;AAC5D;;EAEE;IACE,cAAc;EAChB;EACA;;IAEE,eAAe;IACf,gBAAgB;;AAEpB;;AAEA;;AAEA,0DAA0D;;AAE1D,KAAK;AACL,KAAK;AACL,6DAA6D;;AAE7D;;AAEA;;EAEE,WAAW;;AAEb;AACA;IACI,WAAW;EACb;EACA;IACE,sBAAsB;EACxB;AACF;IACI,cAAc;EAChB;EACA;IACE,sBAAsB;IACtB,gBAAgB;EAClB;;AAEF;;AAEA,2DAA2D","sourcesContent":[".solution-page{\n  display: none;\n}\n\n\n.solution-wrapper {\n    background-color: rgb(238, 238, 238);\n  width: 100%;\n  padding: 20px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 15px;\n  justify-content: center;\n}\n.solution-wrapper a {\n  text-decoration: none;\n}\n\n.Sol-title{\n    background-color: rgb(238, 238, 238);\n    padding-top: 20px;\n    font-size: 38px;\n    font-weight: 700;\n    color: #1e4f6c;\n    text-align: center;\n}\n\n.solution-card {\n  border: 1px solid rgb(219, 219, 219);\n  background-color: rgb(255, 255, 255);\n  width: 200px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 4px 5px;\n  border-radius: 5px;\n  gap: 4px;\n  justify-content: center;\n}\n\n.solution-card:hover {\n  background-color: rgb(241, 241, 241);\n  box-shadow:\n  0px 0px 5.3px rgba(0, 0, 0, 0.04),\n  0px 0px 17.9px rgba(0, 0, 0, 0.06),\n  0px 0px 80px rgba(0, 0, 0, 0.1)\n;\ntransition: all 0.25s;\n\n\n}\n.solution-card img {\n  width: 70px;\n}\n\n.solution-card p {\n  font-size: 14px;\n  text-align: center;\n  font-weight: 500;\n  color: rgb(80, 80, 80);\n}\n\n/* Responsive For Tablet Screen size 767px to 1023px START */\n@media (max-width: 1023px) {\n\n  .solution-page{\n    display: block;\n  }\n  .Sol-title{\n\n    font-size: 24px;\n    font-weight: 700;\n\n}\n\n}\n\n/* Responsive For Tablet Screen size 601px to 1023px END */\n\n/*  */\n/*  */\n/* Responsive For Mobile Screen size 1024px to 1920px START */\n\n@media (max-width: 767px) {\n\n.solution-card {\n\n  width: 80px;\n \n}\n.solution-card img {\n    width: 20px;\n  }\n  .solution-img{\n    width: 50px !important;\n  }\n.solution-card p {\n    font-size: 8px;\n  }\n  .solution-card:hover {\n    background-color:white;\n    box-shadow: none;\n  }\n\n}\n\n/* Responsive For Mobile Screen size 1024px to 1920px END */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
